module.exports = __webpack_public_path__ + "img/img_article5_item_1_v2@2x.ac191012.png";